<template>
  <form @submit.prevent="reset" class="form">
    <p class="form__text">{{ t('auth.reset.text') }}</p>
    <ui-input
        :type="'email'"
        :placeholder="t('fields.email')"
        :rules="[isEmail]"
        v-model="email"
    />
    <ui-button
        :type="'submit'"
        class="form__button"
        :isDisabled="!isFormValid"
        :isLoading="isLoading"
    >
      {{ t('buttons.request') }}
      <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
        <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#01AC1B" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </ui-button>
  </form>
</template>

<script setup>
import {isEmail} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {Auth} from "@/core/api/auth.js";
import {useI18n} from "vue-i18n";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n()

const email = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
      isEmail(email.value) === true
  )
})

const reset = async () => {
  const res = await Auth.resetPassword(email.value);

  ElNotification({
    message: t('popup.reset')
  })
}
</script>

<style lang="scss" scoped>
.form {
  width: 400px;
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__text {
    color: #222;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: -0.16px;

    & a {
      transition: 0.2s;
      color: #008d17;
      font-weight: 600;
      line-height: 27px;
      letter-spacing: -0.16px;
      text-decoration: underline;

      @include hover {
        color: #008014;
      }
    }
  }

  &__link {
    transition: 0.2s;
    color: #008d17;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: -0.16px;
    text-decoration: underline;

    @include hover {
      color: #008014;
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 20px;
    align-self: flex-end;
  }
}

@media (max-width: 600px) {
  .form {
    width: 100%;
  }
}
</style>